import React, { useEffect, useRef, useState } from "react";
import { Field, ErrorMessage, useFormikContext } from "formik";
import EmailTextField from "./EmailTextfield";
import CustomInput from "./CustomInput";
import CustomSelect from "./CustomSelect";
import RfqProjectSelector from "./RfqProjectSelector";
import { Button } from "flowbite-react";
import RfqTypeMaterial from "./RfqTypeMaterial";
import RfqTypeLabour from "./RfqTypeLabour";
import RfqTypeProviding from "./RfqTypeProviding";
import RfqDetailsSection from "./RfqDetailsSection";
import ProjectFormDrawer from "views/Project/components/ProjectFormDrawer";
import { CcMemberList } from "actions/rfqActions";
import { useDispatch } from "react-redux";
import ReactHtmlParser from "react-html-parser";
import AddIndividual from "./AddIndividual";
import ReactQuill from "react-quill";
import rfqService from "services/rfqService";
import {
  findExactMatchingProjectIds,
  mapIndentResponseToRfqValues,
  mapPendingPrResponseToRfqValues,
  parseIndentIds,
} from "utils/indentIntegration";
import { useSnackbar } from "notistack";
import RfqTaxonomySubjectSelector from "./RfqTaxonomySubjectSelector";
import IndentMaterialSelectionDrawer from "./IndentMaterialSelectionDrawer";

const GeneralInformationNew = ({
  projects,
  updateRfqFormValues,
  entityId,
  isEdit = false,
  advancedTransportOptions = false,
  isAnyQuotationReceived = false,
  showBusinessDivisions = false,
  businessDivisionOptions,
  multipleProjectSelection = false,
  indentIntegrationEnabled = false,
  indentApiUrl = "",
  pendingPrIntegrationEnabled = false,
  pendingPrFetchRequest = 0,
  materialMasterEnabled = false,
  materialMasterFetchRequest = 0,
}) => {
  const { values, errors, setFieldValue, touched } = useFormikContext();
  const { enqueueSnackbar } = useSnackbar();
  const [showCreateProjectForm, setShowCreateProjectForm] = useState(false);
  const [rankingMode, setRankingMode] = useState(values.displayRanks || false); // false = Off, true = On
  // const [currentValues, setCurrentValues] = useState({});
  const dispatch = useDispatch();

  const [isFocusedCC, setIsFocusedCC] = useState(false);
  const [addScope, setAddScope] = useState(false);
  const [indentDraftInput, setIndentDraftInput] = useState("");
  const [indentLookupState, setIndentLookupState] = useState({
    loading: false,
    message: "",
    type: "",
  });
  const [indentReviewSliderVisible, setIndentReviewSliderVisible] = useState(false);
  const [indentMaterialReview, setIndentMaterialReview] = useState({
    open: false,
    materials: [],
    selectedIndexes: [],
    projectIds: [],
    indentId: "",
    source: "indent",
    itemType: "material",
    searchTerm: "",
    projectFilters: [],
    categoryFilters: [],
    projectFilterSearch: "",
    categoryFilterSearch: "",
    projectFilterOpen: false,
    categoryFilterOpen: false,
    activeIndentFilter: "all",
  });
  const indentLookupRequestIdRef = useRef(0);

  const getFormikErrorText = (error) => (typeof error === "string" ? error : "");
  const subjectValidationError =
    getFormikErrorText(touched.category && errors.category) ||
    getFormikErrorText(touched.rfqName && errors.rfqName);

  useEffect(() => {
    if (!indentMaterialReview.open) {
      setIndentReviewSliderVisible(false);
      return undefined;
    }

    const animationTimer = setTimeout(() => {
      setIndentReviewSliderVisible(true);
    }, 20);

    return () => clearTimeout(animationTimer);
  }, [indentMaterialReview.open]);

  useEffect(() => {
    if (!pendingPrFetchRequest || !pendingPrIntegrationEnabled || values?.requirementType !== "material") return;

    handleFetchPendingPrMaterials();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pendingPrFetchRequest]);

  useEffect(() => {
    if (!materialMasterFetchRequest || !materialMasterEnabled || values?.requirementType !== "material") return;

    handleFetchMaterialMasterItems();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [materialMasterFetchRequest]);
  const handleAddScopeBox = () => {
    setAddScope(!addScope);
  };

  const handleOpenCreateProjectForm = () => {
    // setCurrentValues(values);
    setShowCreateProjectForm(true);
  };

  const capitalizeFirstLetter = (string) => {
    if (!string) return "";
    return string.charAt(0).toUpperCase() + string.slice(1).toLowerCase();
  };

  // Function to handle project creation and close the form
  const handleProjectCreation = () => {
    setShowCreateProjectForm(false);

    // Restore the form values after the project is created
    // Object.keys(currentValues).forEach((key) => {
    //   setFieldValue(key, currentValues[key]);
    // });
  };

  let otherCharges = [];
  if (
    values.requirementType === "material" ||
    values.requirementType === "contractor"
  ) {
    otherCharges = [
      { label: "Transport", key: "transport" },
      { label: "Loading", key: "loading" },
      { label: "Unloading", key: "unLoading" },
      { label: "Mathade Charges", key: "mathadeCharges" },
      // { label: "Misc. Charges", key: "miscCharges" },
    ];
  } else if (values.requirementType === "labour") {
    otherCharges = [
      { label: "Mathade Charges", key: "mathadeCharges" },
      // { label: "Misc. Charges", key: "miscCharges" },
    ];
  }

  const handleToggle = () => {
    const newRankingMode = !rankingMode;
    setRankingMode(newRankingMode);
    setFieldValue("displayRanks", newRankingMode);
  };

  const handleRadioChange = (key, value) => {
    setFieldValue(`otherCharges.${key}`, value);
  };

  const handleTransportChange = (key, value) => {
    setFieldValue(key, value);
  };

  useEffect(() => {
    dispatch(CcMemberList(entityId));
  }, [dispatch, entityId]);

  useEffect(() => {
    // Avoid resetting 'otherCharges' when it's already set
    if (!values?.otherCharges) {
      setFieldValue("otherCharges", {}); // Only reset if 'otherCharges' is undefined
    }

    // Reset values based on requirementType
    if (values.requirementType === "labour") {
      setFieldValue("providingFixingDetails", []); // Reset providing & fixing details
      setFieldValue("materials", []); // Reset material details
    } else if (values.requirementType === "contractor") {
      setFieldValue("labourDetails", []); // Reset labour details
      setFieldValue("materials", []); // Reset materials
    } else if (values.requirementType === "material") {
      setFieldValue("labourDetails", []); // Reset labour details
      setFieldValue("providingFixingDetails", []); // Reset providing & fixing details
    }
  }, [values.requirementType, setFieldValue]); // Don't include 'values.otherCharges' here

  useEffect(() => {
    if (values?.otherCharges?.transport && !isAnyQuotationReceived) {
      setFieldValue("transportOption", ""); // Reset when transport is No
    }
  }, [values?.otherCharges?.transport]);

  useEffect(() => {
    if (!values?.otherCharges?.miscCharges) {
      setFieldValue("otherCharges.miscCharges", true);
    }
  }, [values?.otherCharges]);

  const showIndentSnackbar = (message, severity = "success") => {
    enqueueSnackbar(message, {
      variant: severity,
      autoHideDuration: 3500,
      anchorOrigin: {
        vertical: "bottom",
        horizontal: "left",
      },
    });
  };

  const getIndentChipValues = () => parseIndentIds(values?.parentsRefId);

  const updateIndentChips = (indentIds = []) => {
    const uniqueIndentIds = [...new Set(indentIds.map((indentId) => String(indentId).trim()).filter(Boolean))];
    setFieldValue("parentsRefId", uniqueIndentIds.join(", "));
  };

  const addIndentIdsToChips = (indentIds = []) => {
    const existingIndentIds = getIndentChipValues();
    const incomingIndentIds = indentIds
      .map((indentId) => String(indentId).trim())
      .filter(Boolean);
    const mergedIndentIds = [...new Set([...existingIndentIds, ...incomingIndentIds])];

    if (mergedIndentIds.length > 5) {
      showIndentSnackbar("You can fetch maximum 5 indents at a time.", "warning");
      updateIndentChips(mergedIndentIds.slice(0, 5));
      return;
    }

    updateIndentChips(mergedIndentIds);
  };

  const handleIndentDraftChange = (event) => {
    const value = event.target.value;

    if (!value.includes(",")) {
      setIndentDraftInput(value);
      return;
    }

    const parts = value.split(",");
    addIndentIdsToChips(parts.slice(0, -1));
    setIndentDraftInput(parts[parts.length - 1] || "");
  };

  const handleIndentDraftKeyDown = (event) => {
    if (event.key !== "Enter" && event.key !== "Tab") return;
    if (!String(indentDraftInput || "").trim()) return;

    event.preventDefault();
    addIndentIdsToChips([indentDraftInput]);
    setIndentDraftInput("");
  };

  const removeIndentChip = (indentId) => {
    updateIndentChips(getIndentChipValues().filter((currentIndentId) => currentIndentId !== indentId));
  };

  const getIndentIdsForFetch = () =>
    parseIndentIds([values?.parentsRefId, indentDraftInput].filter(Boolean).join(","));

  const isIndentFetchSupportedForType = ["material", "labour"].includes(values?.requirementType);
  const isIndentFetchEnabledForCurrentType =
    indentIntegrationEnabled &&
    isIndentFetchSupportedForType &&
    Boolean(indentApiUrl);
  const currentIndentItemType = values?.requirementType === "labour" ? "labour" : "material";
  const isMaterialMasterEnabledForCurrentType =
    materialMasterEnabled && values?.requirementType === "material";

  const handleFetchIndentDetails = async () => {
    const indentIds = getIndentIdsForFetch();
    const indentId = indentIds.join(",");
    const canFetchIndent = isIndentFetchEnabledForCurrentType;

    if (!canFetchIndent) {
      showIndentSnackbar("Indent integration is not enabled for this RFQ.", "warning");
      return;
    }

    if (!indentIds.length) {
      showIndentSnackbar("Please enter an indent/requisition number first.", "warning");
      return;
    }

    if (indentIds.length > 5) {
      showIndentSnackbar("You can fetch maximum 5 indents at a time.", "warning");
      return;
    }

    updateIndentChips(indentIds);
    setIndentDraftInput("");

    const requestId = indentLookupRequestIdRef.current + 1;
    indentLookupRequestIdRef.current = requestId;

    setIndentLookupState({
      loading: true,
      message: `Fetching indent details and preparing ${currentIndentItemType} items...`,
      type: "info",
    });

    try {
      const responseData = await rfqService.fetchIndentDetails({
        entityId,
        indentId,
        rfqType: values?.requirementType,
      });

      if (indentLookupRequestIdRef.current !== requestId) return;

      const mappedValues = mapIndentResponseToRfqValues({
        responseData,
        projects,
        rfqType: values?.requirementType,
      });
      const mappedItems =
        currentIndentItemType === "labour"
          ? mappedValues.labourDetails || []
          : mappedValues.materials || [];

      if (mappedValues.projectIds?.length > 0) {
        setFieldValue("projectName", mappedValues.projectIds.join("||"));
      }

      if (!mappedItems.length && !mappedValues.projectIds?.length) {
        setIndentLookupState({
          loading: false,
          message:"",
          type: "warning",
        });
        showIndentSnackbar(
          "Invalid Indent Number",
          "warning"
        );
        return;
      }

      setIndentLookupState({
        loading: false,
        message: ``,
        type: "success",
      });

      showIndentSnackbar("Indent details fetched successfully.", "success");

      if (mappedItems.length > 0) {
        setIndentMaterialReview({
          open: true,
          materials: mappedItems,
          selectedIndexes: [],
          projectIds: mappedValues.projectIds || [],
          indentId,
          source: "indent",
          itemType: currentIndentItemType,
          searchTerm: "",
          projectFilters: [],
          categoryFilters: [],
          projectFilterSearch: "",
          categoryFilterSearch: "",
          projectFilterOpen: false,
          categoryFilterOpen: false,
          activeIndentFilter: "all",
        });
      }
    } catch (error) {
      if (indentLookupRequestIdRef.current !== requestId) return;

      setIndentLookupState({
        loading: false,
        message:"",
        type: "error",
      });
      showIndentSnackbar(
        "Could not fetch indent details. You can continue manually.",
        "error"
      );
    }
  };

  const handleFetchPendingPrMaterials = async () => {
    const canFetchPendingPr =
      pendingPrIntegrationEnabled &&
      values?.requirementType === "material";

    if (!canFetchPendingPr) {
      showIndentSnackbar("Pending PR integration is not enabled for this RFQ.", "warning");
      return;
    }

    const requestId = indentLookupRequestIdRef.current + 1;
    indentLookupRequestIdRef.current = requestId;

    setIndentLookupState({
      loading: true,
      message: "Fetching pending PR materials...",
      type: "info",
    });

    try {
      const responseData = await rfqService.fetchPendingPrMaterials({ entityId });

      if (indentLookupRequestIdRef.current !== requestId) return;

      const mappedValues = mapPendingPrResponseToRfqValues({ responseData });

      if (!mappedValues.materials?.length) {
        setIndentLookupState({
          loading: false,
          message: "",
          type: "warning",
        });
        showIndentSnackbar("No pending PR material items found.", "warning");
        return;
      }

      setIndentLookupState({
        loading: false,
        message: "",
        type: "success",
      });

      showIndentSnackbar("Pending PR materials fetched successfully.", "success");

      setIndentMaterialReview({
        open: true,
        materials: mappedValues.materials,
        selectedIndexes: [],
        projectIds: mappedValues.projectIds || [],
        indentId: "",
        source: "pendingPr",
        itemType: "material",
        searchTerm: "",
        projectFilters: [],
        categoryFilters: [],
        projectFilterSearch: "",
        categoryFilterSearch: "",
        projectFilterOpen: false,
        categoryFilterOpen: false,
        activeIndentFilter: "all",
      });
    } catch (error) {
      if (indentLookupRequestIdRef.current !== requestId) return;

      setIndentLookupState({
        loading: false,
        message: "",
        type: "error",
      });
      showIndentSnackbar(
        "Could not fetch pending PR materials. You can continue manually.",
        "error"
      );
    }
  };

  const handleFetchMaterialMasterItems = async () => {
    if (!isMaterialMasterEnabledForCurrentType) {
      showIndentSnackbar("Material master is not enabled for this RFQ.", "warning");
      return;
    }

    const requestId = indentLookupRequestIdRef.current + 1;
    indentLookupRequestIdRef.current = requestId;

    setIndentLookupState({
      loading: true,
      message: "Fetching material master list...",
      type: "info",
    });

    try {
      const responseData = await rfqService.getMaterialMaster({
        entityId,
        page: 1,
        limit: 200,
      });

      if (indentLookupRequestIdRef.current !== requestId) return;

      const payload = responseData?.payload || responseData;
      const mappedMaterials = (payload?.materials || []).map((material) => ({
        materialMasterId: material?._id,
        code: material?.code || "",
        name: material?.name || "",
        quantity: "",
        unit: material?.unit || "",
        materialType: material?.materialType || "",
        materialSubType: material?.materialSubType || "",
        brands: material?.brand ? [material.brand] : [],
        brandsInput: material?.brand || "",
        specifications: material?.specification || "",
        category: material?.category || material?.materialSubType || material?.materialType || "",
      }));

      if (!mappedMaterials.length) {
        setIndentLookupState({ loading: false, message: "", type: "warning" });
        showIndentSnackbar("No active materials found in master list.", "warning");
        return;
      }

      setIndentLookupState({ loading: false, message: "", type: "success" });
      showIndentSnackbar("Material master list fetched successfully.", "success");
      setIndentMaterialReview({
        open: true,
        materials: mappedMaterials,
        selectedIndexes: [],
        projectIds: [],
        indentId: "",
        source: "materialMaster",
        itemType: "material",
        searchTerm: "",
        projectFilters: [],
        categoryFilters: [],
        projectFilterSearch: "",
        categoryFilterSearch: "",
        projectFilterOpen: false,
        categoryFilterOpen: false,
        activeIndentFilter: "all",
      });
    } catch (error) {
      if (indentLookupRequestIdRef.current !== requestId) return;

      setIndentLookupState({ loading: false, message: "", type: "error" });
      showIndentSnackbar("Could not fetch material master list. You can continue manually.", "error");
    }
  };
  const toggleIndentMaterial = (index) => {
    setIndentMaterialReview((previousState) => {
      const isSelected = previousState.selectedIndexes.includes(index);

      return {
        ...previousState,
        selectedIndexes: isSelected
          ? previousState.selectedIndexes.filter((selectedIndex) => selectedIndex !== index)
          : [...previousState.selectedIndexes, index],
      };
    });
  };

  const toggleAllIndentMaterials = () => {
    setIndentMaterialReview((previousState) => {
      const visibleIndexes = getVisibleMaterialIndexes(previousState);
      const allSelected =
        visibleIndexes.length > 0 &&
        visibleIndexes.every((index) => previousState.selectedIndexes.includes(index));

      return {
        ...previousState,
        selectedIndexes: allSelected
          ? previousState.selectedIndexes.filter((index) => !visibleIndexes.includes(index))
          : [...new Set([...previousState.selectedIndexes, ...visibleIndexes])],
      };
    });
  };

  const handleCloseIndentMaterialReview = () => {
    setIndentReviewSliderVisible(false);

    setTimeout(() => {
      setIndentMaterialReview((previousState) => ({
        ...previousState,
        open: false,
      }));
    }, 320);
  };

  const handleAddSelectedIndentMaterials = () => {
    if (indentMaterialReview.selectedIndexes.length === 0) {
      showIndentSnackbar("Please select at least 1 item to add.", "warning");
      return;
    }

    const selectedItems = indentMaterialReview.selectedIndexes
      .sort((a, b) => a - b)
      .map((index) => indentMaterialReview.materials[index])
      .filter(Boolean);
    const isLabourIndent = indentMaterialReview.itemType === "labour";

    const isLabourRowFilled = (labour = {}) =>
      Boolean(
        String(labour?.skill || "").trim() ||
        String(labour?.quantity || "").trim() ||
        String(labour?.unit || "").trim() ||
        String(labour?.budget || "").trim()
      );

    const isMaterialRowFilled = (material = {}) =>
      Boolean(
        String(material?.code || "").trim() ||
        String(material?.name || "").trim() ||
        String(material?.quantity || "").trim() ||
        String(material?.unit || "").trim() ||
        String(material?.specifications || "").trim() ||
        (Array.isArray(material?.brands) && material.brands.length > 0) ||
        String(material?.brandsInput || "").trim()
      );
    const existingMaterials = Array.isArray(values?.materials)
      ? values.materials.filter(isMaterialRowFilled)
      : [];

    if (isLabourIndent) {
      const existingLabourDetails = Array.isArray(values?.labourDetails)
        ? values.labourDetails.filter(isLabourRowFilled)
        : [];
      const selectedLabourDetails = selectedItems.map((item) => ({
        skill: item?.skill || "",
        quantity: item?.quantity || "",
        unit: item?.unit || "",
        budget: item?.budget || "",
      }));

      setFieldValue("labourDetails", [...existingLabourDetails, ...selectedLabourDetails]);
      setIndentMaterialReview({
        open: false,
        materials: [],
        selectedIndexes: [],
        projectIds: [],
        indentId: "",
        source: "indent",
        itemType: "material",
        searchTerm: "",
        projectFilters: [],
        categoryFilters: [],
        projectFilterSearch: "",
        categoryFilterSearch: "",
        projectFilterOpen: false,
        categoryFilterOpen: false,
        activeIndentFilter: "all",
      });
      showIndentSnackbar("Selected labour items added to RFQ.", "success");
      return;
    }

    if (indentMaterialReview.source === "pendingPr") {
      const exactProjectIds = findExactMatchingProjectIds(
        projects,
        selectedItems.map((material) => material?.projectName)
      );

      if (exactProjectIds.length > 0) {
        const existingProjectIds = Array.isArray(values?.projectName)
          ? values.projectName
          : String(values?.projectName || "")
              .split("||")
              .map((projectId) => projectId.trim())
              .filter(Boolean);
        const mergedProjectIds = [...new Set([...existingProjectIds, ...exactProjectIds])];

        setFieldValue("projectName", mergedProjectIds.join("||"));
      }
    }

    const materialItemsToAdd = indentMaterialReview.source === "materialMaster"
      ? selectedItems.map((item) => {
          const materialSubType = String(item?.materialSubType || "").trim();
          const materialName = String(item?.name || "").trim();
          const combinedName = [materialSubType, materialName].filter(Boolean).join(" ");

          return {
            ...item,
            name: combinedName || materialName,
          };
        })
      : selectedItems;

    setFieldValue("materials", [...existingMaterials, ...materialItemsToAdd]);
    setIndentMaterialReview({
      open: false,
      materials: [],
      selectedIndexes: [],
      projectIds: [],
      indentId: "",
      source: "indent",
      itemType: "material",
      searchTerm: "",
      projectFilters: [],
      categoryFilters: [],
      projectFilterSearch: "",
      categoryFilterSearch: "",
      projectFilterOpen: false,
      categoryFilterOpen: false,
      activeIndentFilter: "all",
    });
    showIndentSnackbar("Selected material items added to RFQ.", "success");
  };

  const getVisibleMaterialIndexes = (reviewState = indentMaterialReview) => {
    const searchTerm = String(reviewState.searchTerm || "").trim().toLowerCase();
    const projectFilters = Array.isArray(reviewState.projectFilters)
      ? reviewState.projectFilters
      : [];
    const categoryFilters = Array.isArray(reviewState.categoryFilters)
      ? reviewState.categoryFilters
      : [];
    const activeIndentFilter = reviewState.activeIndentFilter || "all";

    return reviewState.materials
      .map((material, index) => ({ material, index }))
      .filter(({ material }) => {
        if (reviewState.source === "pendingPr") {
          if (projectFilters.length > 0 && !projectFilters.includes(material?.projectName)) return false;
          if (categoryFilters.length > 0 && !categoryFilters.includes(material?.category)) return false;
        } else if (
          activeIndentFilter !== "all" &&
          String(material?.sourceIndentId || material?.indentNumber || "") !== activeIndentFilter
        ) {
          return false;
        }

        if (!searchTerm) return true;

        return [
          material?.name,
          material?.projectName,
          material?.category,
          material?.sourceIndentId,
          material?.indentNumber,
          material?.code,
          material?.unit,
          material?.materialSubType,
          material?.specifications,
          material?.brandsInput,
          ...(Array.isArray(material?.brands) ? material.brands : []),
        ].some((value) => String(value || "").toLowerCase().includes(searchTerm));
      })
      .map(({ index }) => index);
  };

  const visibleMaterialIndexes = getVisibleMaterialIndexes();
  const visibleMaterialsSelected =
    visibleMaterialIndexes.length > 0 &&
    visibleMaterialIndexes.every((index) => indentMaterialReview.selectedIndexes.includes(index));

  const sortedProjects = React.useMemo(() => {
    if (!projects) return [];
    return [...projects].sort((a, b) =>
      a.name.localeCompare(b.name, undefined, { sensitivity: "base" })
    );
  }, [projects]);

  return (
    <div className="w-full h-full overflow-y-auto space-y-4 bg-gradient-to-r from-[#FFF0E4] to-[#E4E7FF] px-8 pt-4 pb-10">
      {indentLookupState.loading && (
        <div className="fixed inset-0 z-[9999] bg-black bg-opacity-30 flex items-center justify-center">
          <div className="bg-white rounded-lg shadow-xl px-8 py-6 w-[360px] text-center border border-orange-100">
            <div className="mx-auto mb-4 h-10 w-10 rounded-full border-4 border-orange-200 border-t-orange-500 animate-spin" />
            <p className="text-sm font-semibold text-[#1F1E29]">
              {indentLookupState.message || "Fetching integration details"}
            </p>
            <p className="text-xs text-gray-500 mt-2">
              Preparing material items for this RFQ. This will only take a moment.
            </p>
          </div>
        </div>
      )}
      <section className="rounded-2xl border border-[#E8E6DD] bg-white/90 p-5 shadow-sm">
      <div className="grid grid-cols-13 gap-4">
        <div className="col-span-5 ">
          {/* project address */}
          {/* <div >
          <Field
          as={CustomInput}
          type="text"
          id="projectAddress"
          name="projectAddress"
          placeholder="Enter Credit Project Address"
          label="Project Address"
         />
         <ErrorMessage
          name="projectAddress"
          component="div"
          className="text-red-500 text-xs"
         />
         </div> */}

            {/* rfq Summary */}
          <div className="w-full">
            {["material", "labour", "contractor"].includes(values.requirementType) ? (
              <RfqTaxonomySubjectSelector
                subject={values.rfqName}
                selectedCategory={values.category}
                vendorType="All"
                preferredTaxonomyType={values.requirementType === "material" ? "Material" : "Contractor"}
                error={Boolean(subjectValidationError)}
                helperText={subjectValidationError}
                onSubjectChange={(value) => setFieldValue("rfqName", value)}
                onCategoryChange={(category) => setFieldValue("category", category)}
              />
            ) : (
              <>
                <label htmlFor="rfqName" className="block text-sm font-medium mb-1">
                  RFQ Summary (Subject)<span className="text-red-500 ml-0.5">*</span>
                </label>
                <Field
                  as={CustomInput}
                  type="text"
                  id="rfqName"
                  name="rfqName"
                  // label="RFQ Summary (Subject)"
                  placeholder="RFQ Summary"
                  className="bg-transparent h-[40px] text-sm font-normal"
                />
                <p className="text-[10px] text-[#4F4F42] font-normal mt-1 ">
                  {/* <span className="font-semibold">Note :</span>  Provide the name of RFQ for your internal reference. e.g. <i>  steel, cement, RCC work, etc. </i> */}
                </p>
                <ErrorMessage
                  name="rfqName"
                  component="div"
                  className="text-red-500 text-xs mt-1 "
                />
              </>
            )}
          </div>
        </div>
        {/* <div className=""> */}
        {/* providing Date field */}
        <div className="col-span-2">
          <label
            htmlFor="providingDate"
            className="block text-sm w-full whitespace-nowrap font-medium mb-1"
          >
            {values.requirementType === "material"
              ? "Material Delivery Date"
              : "Work Start Date"}
          </label>
          <Field
            // as={CustomInput}
            type="date"
            id="providingDate"
            name="providingDate"
            // label={values.requirementType === 'material' ? "Expected Delivery Date" : "Expected Work Start Date"}
            className="bg-transparent w-full cursor-pointer mx-auto focus:outline-none focus:ring-0 text-sm placeholder:text-gray-300 placeholder:text-sm border border-gray-300 h-[40px]"
          />
          <ErrorMessage
            name="providingDate"
            component="div"
            className="text-red-500 text-xs mt-1"
          />
        </div>

        {/* Parents Ref Id */}
        <div className="col-span-6 min-w-0">
          <div className=" w-full">
            <label
              htmlFor="parentsRefId"
              className="block text-sm font-medium mb-1"
            >
             Indent/Requisition No.
            </label>
            <div className="flex min-w-0 items-center gap-2">
              <div className="min-w-0 flex-1">
                {isIndentFetchEnabledForCurrentType ? (
                  <div className="flex min-h-[40px] w-full max-w-full items-center gap-1 overflow-hidden rounded-sm border border-gray-300 bg-white px-2 focus-within:border-neevay-theme-surface-700">
                    {getIndentChipValues().map((indentId) => (
                      <span
                        key={indentId}
                        className="inline-flex max-w-[90px] shrink-0 items-center gap-1 rounded-full bg-orange-50 px-2 py-1 text-xs font-medium text-orange-700 ring-1 ring-orange-200"
                        title={indentId}
                      >
                        <span className="truncate">{indentId}</span>
                        <button
                          type="button"
                          onClick={() => removeIndentChip(indentId)}
                          className="text-orange-500 hover:text-orange-900"
                          aria-label={`Remove indent ${indentId}`}
                        >
                          x
                        </button>
                      </span>
                    ))}
                    <input
                      id="parentsRefId"
                      type="text"
                      value={indentDraftInput}
                      onChange={handleIndentDraftChange}
                      onKeyDown={handleIndentDraftKeyDown}
                      onBlur={() => {
                        if (!String(indentDraftInput || "").trim()) return;
                        addIndentIdsToChips([indentDraftInput]);
                        setIndentDraftInput("");
                      }}
                      placeholder={
                        getIndentChipValues().length
                          ? "Add another indent"
                          : "Enter up to 5 indents"
                      }
                      className="h-[34px] min-w-0 flex-1 border-0 bg-transparent text-sm focus:outline-none focus:ring-0"
                    />
                  </div>
                ) : (
                  <Field
                    as={CustomInput}
                    type="text"
                    id="parentsRefId"
                    name="parentsRefId"
                    placeholder="Enter Parents Ref Id"
                    // label="Parents Ref Id"
                  />
                )}
              </div>
              {isIndentFetchEnabledForCurrentType && (
                <button
                  type="button"
                  title="Fetch indent details"
                  disabled={indentLookupState.loading}
                  onClick={handleFetchIndentDetails}
                  className={`h-[38px] w-[38px] shrink-0 rounded-md border flex items-center justify-center transition ${
                    indentLookupState.loading
                      ? "border-orange-200 bg-orange-50 cursor-not-allowed"
                      : "border-orange-300 bg-orange-50 hover:bg-orange-100 text-orange-600"
                  }`}
                >
                  {indentLookupState.loading ? (
                    <span className="h-4 w-4 rounded-full border-2 border-orange-200 border-t-orange-500 animate-spin" />
                  ) : (
                    <svg
                      width="18"
                      height="18"
                      viewBox="0 0 24 24"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M20 11A8 8 0 0 0 6.35 5.35L4 7.7"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4 4v3.7h3.7"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M4 13a8 8 0 0 0 13.65 5.65L20 16.3"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                      <path
                        d="M20 20v-3.7h-3.7"
                        stroke="currentColor"
                        strokeWidth="1.8"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  )}
                </button>
              )}

            </div>
            <ErrorMessage
              name="parentsRefId"
              component="div"
              className="text-red-500 text-xs"
            />
            <p className="text-[#8C8C8C] pt-1 text-[10px]">
            {isIndentFetchEnabledForCurrentType
              ? "Enter an indent and press comma, Enter, or Tab."
              : "Enter Indent or Requisition No."}
          </p>
            {indentIntegrationEnabled &&
              isIndentFetchSupportedForType &&
              indentLookupState.message && (
                <p
                  className={`pt-1 text-[10px] ${
                    indentLookupState.type === "success"
                      ? "text-green-600"
                      : indentLookupState.type === "warning"
                        ? "text-orange-600"
                        : indentLookupState.type === "error"
                          ? "text-red-500"
                          : "text-[#8C8C8C]"
                  }`}
                >
                  {indentLookupState.message}
                </p>
              )}
          </div>
        </div>

       

        {/* project name */}
        <div className="col-span-5">
          <RfqProjectSelector projects={sortedProjects || []} entityId={entityId} isEdit={isEdit} onAddNew={handleOpenCreateProjectForm} multipleSelection={multipleProjectSelection || isIndentFetchEnabledForCurrentType} />
        </div>

        {/* QuotationDeadline */}
        <QuotationDeadline />

        {/* Budget */}
        {/* <div className="col-span-3 flex justify-between">
          <div className=" w-full">
            <label
              htmlFor="rfqBudget"
              className="block text-sm font-medium mb-1"
            >
              Budget
            </label>
            <Field
              as={CustomInput}
              type="text"
              id="rfqBudget"
              name="rfqBudget"
              placeholder="Enter Budget"
              // label="Budget"
            />
            <ErrorMessage
              name="rfqBudget"
              component="div"
              className="text-red-500 text-xs pt-1"
            />
            <p className="text-[#8C8C8C] text-[10px] pt-1">
              This value will not be visible to vendors.
            </p>
          </div>
        </div> */}

         {/* Requirement Type */}
         {!showBusinessDivisions && (
          <div className=" col-span-3">
            <label
              htmlFor="requirementType"
              className="block text-sm w-full whitespace-nowrap font-medium mb-1"
            >
              Requirement Type
            </label>
            <div className="bg-gray-200 text-sm h-[40px] w-full border border-gray-300 text-gray-500 flex items-center p-2">
              {capitalizeFirstLetter(values?.requirementType)}
            </div>
          </div>
        )}

        {/* Business Division */}
        {showBusinessDivisions ? (
          <div className="col-span-3">
            <label
              className="block text-sm font-medium w-full whitespace-nowrap pb-1"
              htmlFor="businessDivision"
            >
              Category<span className="text-red-500 ml-0.5">*</span>
            </label>
            <Field
              component={CustomSelect}
              id="businessDivision"
              name="businessDivision"
              options={businessDivisionOptions}
              placeholder="Select Business Division"
              selectedId={values?.businessDivision}
              selectedOption={
                values?.businessDivision
                  ? businessDivisionOptions?.find(
                      (opt) => opt.value === values.businessDivision
                    )?.label
                  : ""
              }
              onChange={(option) => {
                if (option?.value !== values?.businessDivision) {
                  setFieldValue("businessDivision", option?.value || "");
                }
              }}
            />
            <ErrorMessage
              name="businessDivision"
              component="div"
              className="text-red-500 text-xs mt-1"
            />
          </div>
        ) : (
          // <QuotationDeadline />
          ""
        )}

{/* Show Rank to Vendors */}
        <div className="col-span-3 mt-7">
          <div className="flex items-end space-x-2">
            <p className="text-sm font-medium">Show Rank to Vendors :</p>
            {/* Ranking Mode Selection */}
            <div className="flex items-center justify-between">
              {/* <p className="text-sm font-medium">Ranking Mode :</p> */}
              <button
                type="button"
                className={`relative w-8 h-4 mb-1 rounded-full p-0.5 transition duration-300 ${
                  rankingMode ? "bg-blue-600" : "bg-gray-300"
                }`}
                onClick={handleToggle}
              >
                <div
                  className={`w-3 h-3 bg-white rounded-full shadow-md transform transition ${
                    rankingMode ? "translate-x-4" : "translate-x-0"
                  }`}
                />
              </button>
            </div>
          </div>
          {/* <RankingMode /> */}
          <p className="text-[#8C8C8C] text-[10px]">
            {rankingMode
              ? "Vendors can see their quotation rank."
              : "Vendors cannot see their quotation rank."}
          </p>
        </div>
      </div>
      </section>
      <div className="col-span-6 row-span-2">
        {/* email */}
        {/* <div className="w-full min-h-[120px] max-h-[150px]">
            <label
              htmlFor="emailCopyRecipients"
              className="block text-sm font-medium mb-1"
            >
              RFQ Watchers (emails)
            </label>
            <Field
              as={EmailTextField}
              name="emailCopyRecipients"
              id="emailCopyRecipients"
              className="bg-transparent h-full text-sm placeholder:text-sm border border-gray-300 rounded-md flex-grow resize-none focus:outline-none focus:ring-0 w-full" // Increased min and max height
              onFocus={() => setIsFocusedCC(true)}
              onBlur={() => setIsFocusedCC(false)}
            />
            <ErrorMessage
              name="emailCopyRecipients"
              component="div"
              className="text-red-500 text-xs mt-1"
            />
          </div> */}
      </div>
      {/* </div> */}

      {/* <div className="grid grid-cols-13 gap-2"> */}

      {/* {showBusinessDivisions ? ( */}

      {/* ) : (
          <div className="col-span-2"></div>
        )} */}

      {/* </div> */}

      {/* rfq type */}
      {/* <div>
        <Field
          className="cursor-pointer"
          component={CustomSelect}
          id="requirementType"
          name="requirementType"
          options={[
            {
              value: "contractor",
              label: "Contractor With Material",
              description: "Select this option if this requirement is for Turnkey Contractor",
            },
            {
              value: "labour",
              label: "Labour",
              description: "Select this option if this requirement is for Labour",
            },
            {
              value: "material",
              label: "Material",
              description: "Select this option if this requirement is for Material",
            },
          ]}
          placeholder="Requirement Type"
          selectedId={values?.requirementType}
          selectedOption={capitalizeFirstLetter(values?.requirementType)}
          onChange={(option) => setFieldValue("requirementType", option.value)}
          alwaysShowOptions={true} // This prop can be utilized in CustomSelect
        />
        <ErrorMessage
          name="requirementType"
          component="div"
          className="text-red-500 text-xs p-0 mt-1"
        />
      </div> */}

      <section className="bg-white p-4 rounded-xl border">
        {/* Conditionally render components based on requirementType */}
        {values.requirementType === "material" && <AddIndividual />}
        {values.requirementType === "labour" && <RfqTypeLabour />}
        {values.requirementType === "contractor" && <RfqTypeProviding />}
      </section>

      <section className="grid grid-cols-2 items-stretch gap-4">
        <div className="flex h-full flex-col rounded-2xl border border-[#E8E6DD] bg-white/90 p-5 shadow-sm">
          {/* miscellaneous otherCharges */}
          {/* {values.requirementType === 'material' &&  */}
          {/* {(values.requirementType === 'labour' || values.requirementType === 'material' && */}
          <div className="w-full h-fit">
            <div className="mb-4 flex items-start justify-between gap-4">
              <div>
                <p className="text-sm font-semibold text-[#1F2937]">Additional Cost Components</p>
                <p className="text-[#8C8C8C] text-[10px]">
                  Select whether additional cost is needed for the quotation.
                  Vendors will fill them in when sending their offers.
                </p>
              </div>
            </div>

            <div className="space-y-2">
              {otherCharges.map(({ key, label }) => (
                <div key={key} className="rounded-xl border border-[#EFEFE8] bg-[#FCFCFA] px-4 py-2 gap-y-2">
                  <div className="flex items-center justify-between gap-4">
                    <span className="text-[#434343] text-sm font-medium">{label}</span>
                    <div className="flex items-center space-x-6">
                    <label
                      className={`inline-flex items-center text-sm ${
                        isAnyQuotationReceived && key === "transport"
                          ? ""
                          : "cursor-pointer"
                      }`}
                    >
                      <input
                        type="radio"
                        name={`otherCharges.${key}`}
                        value="yes"
                        className="h-3 w-3 focus:ring-0"
                        checked={values?.otherCharges?.[key] === true}
                        onChange={() => handleRadioChange(key, true)}
                        disabled={isAnyQuotationReceived && key === "transport"}
                      />
                      <span className={`ml-2 text-sm text-[#505050]`}>Yes</span>
                    </label>

                    <label
                      className={`inline-flex items-center ${
                        isAnyQuotationReceived && key === "transport"
                          ? ""
                          : "cursor-pointer"
                      }`}
                    >
                      <input
                        type="radio"
                        name={`otherCharges.${key}`}
                        value="no"
                        className="h-3 w-3 focus:ring-0"
                        checked={values?.otherCharges?.[key] === false}
                        onChange={() => handleRadioChange(key, false)}
                        disabled={isAnyQuotationReceived && key === "transport"}
                      />
                      <span className={`ml-2 text-sm text-[#505050]`}>No</span>
                    </label>
                    </div>
                  </div>

                  {/* Transport Sub-options (only for Material type) */}
                  {advancedTransportOptions &&
                    key === "transport" &&
                    values.requirementType === "material" &&
                    values.otherCharges?.transport && (
                      <div className="flex space-x-6 mt-2 col-span-2">
                        {[
                          { key: "lumpsumAmount", label: "Lumpsum Amount" },
                          { key: "perUnitAmount", label: "Per Unit Amount" },
                        ].map(({ key, label }) => (
                          <label
                            key={key}
                            className={`flex items-center space-x-2 text-[10px] text-[#434343] ${
                              isAnyQuotationReceived ? "" : "cursor-pointer"
                            }`}
                          >
                            <input
                              type="radio"
                              name="transportOption"
                              value={key}
                              className="h-3 w-3 focus:ring-0"
                              checked={values.transportOption === key}
                              onChange={() =>
                                handleTransportChange("transportOption", key)
                              }
                              disabled={isAnyQuotationReceived}
                            />
                            <span>{label}</span>
                          </label>
                        ))}
                      </div>
                    )}
                </div>
              ))}
            </div>

            {/* Error Message */}
            <p className="text-red-500 text-xs mt-1">
              {touched?.otherCharges && errors?.otherCharges && (
                <span>{errors?.otherCharges}</span>
              )}

              {errors?.transportOption && (
                <p className="text-red-500 text-xs mt-1">
                  {errors?.transportOption}
                </p>
              )}
            </p>
          </div>
        </div>

        <div className="flex h-full flex-col rounded-2xl border border-[#E8E6DD] bg-white/90 p-5 shadow-sm">
          <h3 className="text-sm font-semibold text-[#1F2937] pb-2">Payment Terms</h3>
          {/* <label className="inline-flex justify-start space-x-10 items-center w-full mb-3 cursor-pointer">
            <span className="text-sm font-normal text-[#505050] dark:text-gray-300">
              Vendor can offer counter terms
            </span>
            <div className="flex items-center space-x-4 ml-auto">
              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="acceptCounterTerms"
                  value="yes"
                  className="h-3 w-3" // Add margin for spacing
                  onChange={(e) => setFieldValue('acceptCounterTerms', e.target.value === 'yes')}
                  defaultChecked
                />
                <span className="ml-2 text-[#505050] text-sm">Yes</span>
              </label>

              <label className="inline-flex items-center cursor-pointer">
                <input
                  type="radio"
                  name="acceptCounterTerms"
                  value="no"
                  className="h-3 w-3" // Add margin for spacing
                  onChange={(e) => setFieldValue('acceptCounterTerms', e.target.value === 'yes')}
                />
                <span className="ml-2 text-[#505050] text-sm">No</span>
              </label>
            </div>
          </label> */}
          <div className="flex min-h-0 flex-1">
            <RfqDetailsSection
              fieldName="paymentTerms"
              updateFormValues={updateRfqFormValues}
              showLabel={false}
              placeholder="Please write your payment terms here"
              className="placeholder:text-sm"
              hideAttachments
              containerClassName="flex h-full w-full flex-col"
              editorClassName="h-full max-h-[300px] min-h-[100px] overflow-y-auto custom-quill-editor"
            />
          </div>
        </div>
      </section>

      <section className="rounded-2xl border border-[#E8E6DD] bg-white p-5 shadow-sm">
        <div className="mb-3">
          <h3 className="text-sm font-semibold text-[#1F2937]">
            Supporting Documents
          </h3>
          <p className="text-[10px] text-[#8C8C8C]">
            Attach files that help vendors understand the RFQ better.
          </p>
        </div>
        <RfqDetailsSection
          updateFormValues={updateRfqFormValues}
          attachmentsOnly
        />
      </section>

      <section className="flex flex-col rounded-2xl border border-[#E8E6DD] bg-white/90 p-5 shadow-sm">
        <p className="text-sm font-semibold text-[#1F2937] pb-2">Terms & Conditions</p>
        <div className="flex-1">
          <ReactQuill
            value={values.termsAndConditions}
            onChange={(value) => setFieldValue("termsAndConditions", value)}
            theme="snow"
            modules={{ toolbar: false }}
            placeholder="Enter overall RFQ's terms & conditions for vendor "
            className="h-[100px] max-h-[300px] min-h-[100px] overflow-y-auto"
          />
          <ErrorMessage
            name={"termsAndConditions"}
            component="div"
            className="text-red-500 text-xs"
          />
        </div>
      </section>

      {values?.rfqDetails && (
        <div className="pb-10 space-y-2">
          <h3 className="text-[#434343] font-medium">Old RFQ Details</h3>
          <div className="border px-4 py-2 bg-gray-100 text-gray-500">
            {values?.indentId && (
              <p>
                {" "}
                <b>IndentId : </b> {values?.indentId}{" "}
              </p>
            )}
            {values?.rfqDetails && (
              <div className="whitespace-pre-wrap break-words leading-5">
                {ReactHtmlParser(values?.rfqDetails)}
              </div>
            )}
          </div>
        </div>
      )}

      <IndentMaterialSelectionDrawer
        open={indentMaterialReview.open}
        isVisible={indentReviewSliderVisible}
        reviewState={indentMaterialReview}
        setReviewState={setIndentMaterialReview}
        visibleMaterialIndexes={visibleMaterialIndexes}
        visibleMaterialsSelected={visibleMaterialsSelected}
        onClose={handleCloseIndentMaterialReview}
        onAdd={handleAddSelectedIndentMaterials}
        onToggleMaterial={toggleIndentMaterial}
        onToggleAll={toggleAllIndentMaterials}
      />

      <ProjectFormDrawer
        open={showCreateProjectForm}
        onClose={() => setShowCreateProjectForm(false)}
        onProjectCreated={handleProjectCreation}
      />
    </div>
  );
};

const QuotationDeadline = () => (
  <div className="col-span-2">
    <label
      htmlFor="quotationDeadline"
      className="block text-sm w-full whitespace-nowrap font-medium mb-1"
    >
      Quotation Deadline
    </label>
    <Field
      type="date"
      id="quotationDeadline"
      name="quotationDeadline"
      className="bg-transparent w-full cursor-pointer mx-auto focus:outline-none focus:ring-0 text-sm placeholder:text-gray-300 placeholder:text-sm border border-gray-300 h-[40px]"
    />
    <ErrorMessage
      name="quotationDeadline"
      component="div"
      className="text-red-500 text-xs mt-1"
    />
  </div>
);

export default GeneralInformationNew;
